module.exports = __webpack_public_path__ + "static/media/newsletter-march-2022-2.386af37d.jpg";